export class Folder {
    id = ""
    name = ""
    orderindex = 0
    constructor(data) {
        Object.assign(this, data)
    }
}